import { describe_error } from './ErrorDescriber';
import axios from 'axios';

import Constants from '../Constants';

// How often the report's progress is polled, and how many polls before giving up on a report that never arrives.
const c_PdfProgressPollMs = 1000;
const c_MaxPdfProgressPolls = 180;

const c_DefaultFilename = 'AEOAudited_site_report.pdf';

// The report's filename from the download response's Content-Disposition header.
const get_download_filename = (response)=>{
	const content_disposition = response.headers['content-disposition'];
	if(content_disposition){
		const match = content_disposition.match(/filename="([^"]+)"/);
		if(match){
			return match[1];
		}
	}

	return c_DefaultFilename;
};

// Hands the PDF to the browser as a download under the given filename.
const save_pdf = (pdf_blob, filename)=>{
	const object_url = window.URL.createObjectURL(pdf_blob);
	const link = document.createElement('a');
	link.href = object_url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(object_url);
};

// Stops a running export's progress polling. Each site view calls it when it unmounts, so no poll outlives it.
export const stop_site_pdf_polling = (poll_interval_ref)=>{
	if(poll_interval_ref.current){
		clearInterval(poll_interval_ref.current);
		poll_interval_ref.current = null;
	}
};

const download_pdf = async(token, site_analysis_id)=>{
	const download_url = Constants.SERVER_URL + '/api/site_pdf_report_download/' + site_analysis_id;
	const response = await axios.get(download_url, { headers: { Authorization: 'Bearer ' + token }, responseType: 'blob' });
	const pdf_blob = new Blob([response.data], { type: 'application/pdf' });
	save_pdf(pdf_blob, get_download_filename(response));
};

const on_export_failed = (export_state, error)=>{
	stop_site_pdf_polling(export_state.poll_interval_ref);
	export_state.set_fetching_pdf(false);
	export_state.set_pdf_stage('');
	console.log('SitePdfExport/export_site_pdf - ERROR: ', describe_error(error));
	export_state.set_error_message('The PDF report could not be generated. Please try again.');
};

// The site report export, shared by the site views: queues the report, polls its progress and downloads it when
// done. export_state is the calling view's own state: { set_fetching_pdf, set_pdf_stage, set_error_message,
// poll_interval_ref }. fetching_pdf and pdf_stage drive the progress modal; error_message is set when the export
// fails.
export const export_site_pdf = async(token, site_analysis_id, export_state)=>{
	if(!site_analysis_id){
		export_state.set_error_message('There is no site analysis to export.');
		return;
	}

	const headers = { Authorization: 'Bearer ' + token };

	try {
		export_state.set_error_message('');
		export_state.set_pdf_stage('');
		export_state.set_fetching_pdf(true);

		await axios.post(Constants.SERVER_URL + '/api/site_pdf_report/' + site_analysis_id, {}, { headers });

		const progress_url = Constants.SERVER_URL + '/api/get_site_pdf_report_progress/' + site_analysis_id;
		var num_polls = 0;

		stop_site_pdf_polling(export_state.poll_interval_ref);
		export_state.poll_interval_ref.current = setInterval(async()=>{
			try {
				++num_polls;
				if(num_polls > c_MaxPdfProgressPolls){
					throw new Error('Site PDF report timed out');
				}

				const progress_response = await axios.post(progress_url, {}, { headers });
				if(!progress_response || !progress_response.data){
					return;
				}

				const { progress, stage } = progress_response.data;
				if(stage){
					export_state.set_pdf_stage(stage);
				}

				if(progress == 100){
					stop_site_pdf_polling(export_state.poll_interval_ref);
					export_state.set_pdf_stage('downloading');
					await download_pdf(token, site_analysis_id);
					export_state.set_fetching_pdf(false);
					export_state.set_pdf_stage('');
				}
			}
			catch (error) {
				on_export_failed(export_state, error);
			}
		}, c_PdfProgressPollMs);
	}
	catch (error) {
		on_export_failed(export_state, error);
	}
};
